import { useEffect, useMemo, useState } from 'react';
import { constants } from '../lib/constants';

/**
 * Catálogo público de procesos (categorías + integraciones + ficha comercial).
 *
 * Única fuente para /services, /playbooks y la calculadora de ROI: antes cada
 * pantalla tenía su propio fetch (o datos a mano). El endpoint devuelve las
 * categorías con sus integraciones y, en cada una, `commercial` con la ficha
 * comercial (o null si todavía no está sembrada).
 */
const useIntegrationsCatalog = () => {
   const [categories, setCategories] = useState([]);
   const [isLoading, setIsLoading] = useState(true);
   const [hasError, setHasError] = useState(false);

   useEffect(() => {
      let isMounted = true;
      setIsLoading(true);
      setHasError(false);
      fetch(constants.getIntegrations)
         .then((res) => res.json())
         .then((data) => {
            if (!isMounted) return;
            setCategories(Array.isArray(data) ? data : []);
            setIsLoading(false);
         })
         .catch((e) => {
            if (!isMounted) return;
            console.log(e);
            setHasError(true);
            setIsLoading(false);
         });
      return () => {
         isMounted = false;
      };
   }, []);

   const safeCategories = useMemo(
      () => (Array.isArray(categories) ? categories : []),
      [categories]
   );

   // Lista plana de procesos, cada uno con la categoría a la que pertenece.
   const integrations = useMemo(
      () =>
         safeCategories.flatMap((category) => {
            const list = Array.isArray(category?.integrations) ? category.integrations : [];
            return list.map((integration) => ({
               ...integration,
               categoryTitle: category?.title || '',
               categoryCode: category?.code || '',
            }));
         }),
      [safeCategories]
   );

   return { safeCategories, integrations, isLoading, hasError };
};

export default useIntegrationsCatalog;
